import { Card, Modal } from 'antd'
import { CloseCircleOutlined, UserSwitchOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import './style.less'
import { httpDelete } from '../../services/http'
import { ITaxYear } from '../ComplianceReports/types'
import ChangeAdvisorAccessModal from './ChangeAdvisorAccessModal'

const { Meta } = Card

function Avatar({ name }: { name: string }) {
    return (
        <h3 className="revisor-avatar">
            {name
                .trim()
                .split(' ')
                .slice(0, 2)
                .map((n) => n[0].toUpperCase())
                .join('')}
        </h3>
    )
}

export default function AdvisorUserDisplay({
    loadOverviewData,
    taxYear,
}: {
    taxYear: ITaxYear,
    loadOverviewData: (i?: string) => Promise<ITaxYear[]>,
}) {
    const [changeAccessVisible, setChangeAccessVisible] = useState<boolean>(false)

    async function removeAccess() {
        await httpDelete(`/ll-user-to-advisor/${taxYear.id}/advisor-access/${taxYear.advisor_id}`)
        await loadOverviewData()
    }

    return (
        <div>
            <Card style={{ background: '#ececec' }}>
                <Card
                    style={{ background: '#fafafa' }}
                    actions={[
                        <span
                            onClick={() => {
                                Modal.error({
                                    title: (
                                        <p>
                                            Removing access for your advisor can not be undone.
                                            <br />
                                            Please be absolutely sure about this.
                                        </p>
                                    ),
                                    onOk: removeAccess,
                                    okText: 'Remove Access',
                                    closable: true,
                                    maskClosable: true,
                                })
                            }}
                        >
                            <CloseCircleOutlined key="removeAccess" /> Remove access
                        </span>,
                        <span
                            onClick={()=>{setChangeAccessVisible(true)}}
                        >
                            <UserSwitchOutlined onClick={() => {}} key="changeAccess" />
                            Change
                            access
                        </span>,
                    ]}
                >
                    <Meta
                        avatar={<Avatar name={taxYear.advisor_name} />}
                        title={
                            <div>
                                {taxYear.advisor_company_name} - {taxYear.advisor_name}
                            </div>
                        }
                        description={taxYear.advisor_email}
                    />
                    <br />
                    <br />
                    <h4>Status: </h4>
                    {taxYear.advisor_accepted ? (
                        <h3 style={{ color: '#7EAC55' }}>Advisor has accepted</h3>
                    ) : (
                        <h3 style={{ color: '#14143C' }}>Advisor request is pending</h3>
                    )}
                    Current access: {taxYear.advisor_scopes}
                </Card>
            </Card>
            <ChangeAdvisorAccessModal loadOverviewData={loadOverviewData} setVisible={setChangeAccessVisible} visible={changeAccessVisible} taxYear={taxYear}  />
        </div>
    )
}
